import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import GemArea from '../gameItems/GemArea';
import NavBar from '../gameItems/NavBar';
import Popup from '../gameItems/Popup';
import ABCyaLib from '@abcya/abcya_lib';

/**
 * This is your first scene.
 */
export default class Game extends Phaser.Scene
{
    static get KEY() { return 'Game'; }

    preload()
    {
        // preload your assets here, if needed
        this.anims.create({ key: "explode", frames: this.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, { start: 0, end: 9, prefix: "btnEx_" }), frameRate: 24});
    }

    create()
    {
        console.log("creating GAME", gameData.GAME_MODE, gameData.GAME_LEVEL);
        gameData.GAME_STATE = "Game";
        gameData.MUTE = false;

        this.checkStorage();

        this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);

        this.jingle = ABCyaPhaser.Audio.createSound(this);
        ABCyaPhaser.Audio.playSound("Jingle", this.jingle, 0.1, true);

        this.bg = ABCyaPhaser.Images.addImage(this.mid.x, this.mid.y, "bg", this);

        this.createGems();
        this.createNav();
    };

    checkStorage()
    {
        let DATA = ABCyaLib.Storage.getObject("levels");
        const lvls = [{locked:false, score:0},
            {locked:true, score:0},
            {locked:true, score:0},
            {locked:true, score:0},
            {locked:true, score:0},
            {locked:true, score:0},
            {locked:true, score:0},
            {locked:true, score:0},
            {locked:true, score:0}];
        if(!DATA || DATA == [] || DATA.length == 0){
            console.log("NO LEVELS BEATEN");
            ABCyaLib.Storage.saveObject("levels", lvls);
        }
        DATA = ABCyaLib.Storage.getObject("levels") ?? lvls;
        gameData.LEVELS = DATA;
    }

    createGems(){
        this.gemArea = new GemArea(this);
    };

    createNav(){
        this.navBar = new NavBar(this);
    };

    showPopup(type){
        console.log("POPUP", this.popup)
        gameData.GAME_PAUSED = true;
        this.navBar.setListeners("off");
        this.gemArea.setUI(false);
        this.gemArea.toggleHand(true);

        if(!this.popup){
            this.popup = new Popup(this, type);
        }
    };

    destroyPopup(type){
        this.popup.destroy();
        this.popup = null;
        gameData.GAME_PAUSED = false;
        this.gemArea.toggleHand(false);

        if(type == "resume"){
            this.navBar.setListeners("on");

            if(gameData.QUESTIONING){
                this.navBar.setListeners("answer");
            } else {
                this.gemArea.setUI(true);
            }
        }
    };

    cleanUp(){
        console.log("cleaning up game");
        
        this.sound.stopAll();
        this.sound.removeAll();
        this.tweens.killAll();

        gameData.SCORE = 0;
        gameData.SPEED = 10000;
        gameData.GAME_PAUSED = false;
        gameData.GAME_DONE = false;
        gameData.GAME_LEVEL = 0;
        gameData.INTRO_STEP = 0;
        gameData.PREV_GEM = null;
        gameData.ANSWER = null;
        gameData.SELECTED_GEM = null;
        gameData.SPECIAL_GEM = false;
        gameData.GAME_END = false;
        gameData.QUESTIONING = true;
        gameData.GRABBING = true;

        this.gemArea.removeAll(true);
        this.navBar.removeAll(true);
        this.popup?.removeAll(true);
        this.popup?.destroy();
        this.gemArea.destroy();
        this.navBar.destroy();
        this.popup = null;
        this.gemArea = null;
        this.navBar = null;

        this.children.removeAll(true);

        this.scene.start("Intro");
    };
}